import {
  CeltraLoadingStrategy,
  FlashtalkingLoadingStrategy,
  OcsLoadingStrategy,
  DcmLoadingStrategy
} from './redirect-strategies';
import { RedirectStyleLoadingStrategy } from './style-strategies/redirect-style-strategy';
import { UnloadEmptyTagLoadingStrategy } from './unload-empty-tag-strategy';
import { InArticleObjectFitCoverStrategy } from './in-article-object-fit-cover-strategy';
import { ImageHeaderFooterCropStrategy } from './style-strategies/image-header-footer-crop-strategy';
import { DebugLog } from '../../../../common/js/debug-log';
import { iOSWebviewKeepAliveStrategy } from './ios-webview-keep-alive-strategy';

export type FormatContext = any;

export interface ILoadingStrategy {
  isRunnable(formatContext: FormatContext): boolean;
  alterConfiguration(formatContext: FormatContext): FormatContext;
  onBeforeRender(formatContext: FormatContext): void;
  onAfterRender(formatContext: FormatContext): void;
  onResize(formatContext: FormatContext): void;
}

export class LoadingStrategyFactory implements ILoadingStrategy {
  private static instance: LoadingStrategyFactory;

  static getInstance(): LoadingStrategyFactory {
    if (!LoadingStrategyFactory.instance) {
      LoadingStrategyFactory.instance = new LoadingStrategyFactory();
    }

    return LoadingStrategyFactory.instance;
  }

  protected strategies: ILoadingStrategy[] = [
    new OcsLoadingStrategy(),
    new CeltraLoadingStrategy(),
    new FlashtalkingLoadingStrategy(),
    new RedirectStyleLoadingStrategy(),
    new DcmLoadingStrategy(),
    new UnloadEmptyTagLoadingStrategy(),
    new InArticleObjectFitCoverStrategy(),
    new ImageHeaderFooterCropStrategy(),
    new iOSWebviewKeepAliveStrategy()
  ];

  isRunnable(): boolean {
    return true;
  }

  alterConfiguration(formatContext: FormatContext): FormatContext {
    this.loopOnStrategies(formatContext, s => {
      DebugLog.log(
        `LoadingStrategyFactory: alter configuration for ${s.constructor.name}`,
        formatContext
      );
      formatContext = s.alterConfiguration(formatContext);
      DebugLog.log(
        `LoadingStrategyFactory: configuration altered for ${s.constructor.name}`,
        formatContext
      );
    });

    return formatContext;
  }

  onBeforeRender(formatContext: FormatContext): void {
    this.loopOnStrategies(formatContext, s => {
      DebugLog.log(
        `LoadingStrategyFactory: execute onBeforeRender for ${s.constructor.name}`,
        formatContext
      );
      s.onBeforeRender(formatContext);
    });
  }

  onAfterRender(formatContext: FormatContext): void {
    this.loopOnStrategies(formatContext, s => {
      DebugLog.log(
        `LoadingStrategyFactory: execute onAfterRender for ${s.constructor.name}`,
        formatContext
      );
      s.onAfterRender(formatContext);
    });
  }

  onResize(formatContext: FormatContext): void {
    this.loopOnStrategies(formatContext, s => {
      DebugLog.log(
        `LoadingStrategyFactory: execute onResize for ${s.constructor.name}`,
        formatContext
      );
      s.onResize(formatContext);
    });
  }

  private loopOnStrategies(
    formatContext: FormatContext,
    cb: (strategy: ILoadingStrategy) => void
  ): void {
    this.strategies
      .filter(strategy => strategy.isRunnable(formatContext))
      .forEach(cb);
  }
}
